<template>
  <div
    class="absolute text-white"
    :class="viewportRotationClasses"
  >
    <div class="w-full h-full flex flex-col justify-center items-center gap-8 bg-amber-950/95 px-6">
      <div class="flex flex-col items-center gap-6 text-center max-w-2xl">
        <div class="flex items-center justify-center gap-3 text-amber-400">
          <TriangleAlert class="size-14 xl:size-16 shrink-0" />
        </div>
        <h1 class="text-3xl xl:text-5xl font-black tracking-tight text-white">
          Tenant quota exceeded
        </h1>
        <p class="text-lg xl:text-xl text-amber-100/90 leading-relaxed">
          Playback has been stopped. Please request further capacity from your account manager.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { TriangleAlert } from 'lucide-vue-next'
import { usePlayerViewportRotationClasses } from '@/composables/usePlayerViewportRotationClasses'

const { viewportRotationClasses } = usePlayerViewportRotationClasses()
</script>
